import React, { PropsWithChildren } from "react";
import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "./AuthContext";

const UnAuthenticatedRoute: React.FC<PropsWithChildren> = () => {
  const { user } = useAuthContext();

  if (user) {
    return <Navigate to="/" />;
  } else {
    return <Outlet />
  }
};

export default UnAuthenticatedRoute;
